import {inject, Injectable} from '@angular/core';

import {OptionsStore} from '../state/options.store';
import {OptionsState} from '../models/optionsstate.model';

@Injectable({
  providedIn: 'root',
})
export class OptionsUpdateFacade {
  readonly #store = inject(OptionsStore);

  setOptions(options: Partial<OptionsState>): void {
    this.#store.setOptions(options);
  }
}
